export type { TopBarThemedProps } from './top-bar-themed';
export * from './top-bar-themed.routes';

export { default as TopBarThemed, default } from './top-bar-themed';
